import { render, staticRenderFns } from "./insurance-multiple.vue?vue&type=template&id=b294f29a"
import script from "./insurance-multiple.vue?vue&type=script&lang=js"
export * from "./insurance-multiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports